export const documentConstants = {
  GETALL_REQUEST: "DOCUMENTS_GETALL_REQUEST",
  GETALL_SUCCESS: "DOCUMENTS_GETALL_SUCCESS",
  GETLISTFROMFILE_SUCCESS: "DOCUMENTS_GETLISTFROMFILE_SUCCESS",
  GETALL_FAILURE: "DOCUMENTS_GETALL_FAILURE",
  EXPAND_ROW: "DOCUMENTS_EXPAND_ROW",
  CLEAR_DOCUMENTS: "CLEAR_DOCUMENTS",
  RESET_DOCUMENTS: "RESET_DOCUMENTS",
  SET_ACTIVE_ROW: "DOCUMENTS_SET_ACTIVE_ROW",
  //SET_PARAM_CHANNEL: 'DOCUMENTS_SET_PARAM_CHANNEL',
  SET_DOC_LIST_PARAMS: "SET_DOC_LIST_PARAMS",
  TOGGLE_HIDDEN_COLUMNS: "DOCUMENTS_TOGGLE_HIDDEN_COLUMNS",
  TOGGLE_SHOW_COLUMN_MENU: "DOCUMENTS_TOGGLE_SHOW_COLUMN_MENU",
  SET_HIDDEN_COLUMNS: "DOCUMENTS_SET_HIDDEN_COLUMNS",

  GET_DOWNLOAD_REQUEST: "DOCUMENTS_GET_DOWNLOAD_REQUEST",
  GET_DOWNLOAD_SUCCESS: "DOCUMENTS_GET_DOWNLOAD_SUCCESS",

  TOGGLE_DOWNLOAD_SPINNER: "DOCUMENTS_TOGGLE_DOWNLOAD_SPINNER",
  SET_DOWNLOAD_FILE_PARAMS: "DOCUMENTS_SET_DOWNLOAD_FILE_PARAMS",
  SET_EMAIL_SENT: "DOCUMENTS_SET_EMAIL_SENT",
  SET_EMAIL_FAILED_BUT_DOWNLOAD_READY: "DOCUMENTS_SET_EMAIL_FAILED_BUT_DOWNLOAD_READY"
};
